var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-button',_vm._g(_vm._b({attrs:{"color":"primary"}},'basic-button',_vm.$attrs,false),_vm.$listeners),[(_vm.$vuetify.breakpoint.smAndUp)?_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text || _vm.$t('save')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }